import { stepsDescriptions } from '../../config';
import type { IOrderedStep, IStepperFormsSet } from '../../types';

function counter() {
  let count = 0;
  return () => {
    count += 1;

    return count;
  };
}

export function generateSteps(forms: IStepperFormsSet) {
  const steps: IOrderedStep[] = [];

  const iterator = counter();

  stepsDescriptions
    .filter(({ formId }) => forms[formId]?.isActive)
    .forEach(({ formId }) => {
      steps.push({ formId, stepIndex: iterator(), type: 'single' });
    });

  return steps;
}
